import React from 'react';
import * as PropTypes from 'prop-types';
import I18n from 'i18n-js';

import InputField from 'components/form-field/input-field/input-field';
import {
  FIELD_PLACEHOLDER,
  VALIDATE_MESSAGE,
} from 'constants/booking-constants';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  invalidMessage: PropTypes.string,
  maxLengthMessage: PropTypes.string,
  minLengthMessage: PropTypes.string,
  placeholder: PropTypes.string,
  isSender: PropTypes.bool.isRequired,
};

const defaultProps = {
  // I18n string cannot be defined in default props.
  invalidMessage: undefined,
  maxLengthMessage: undefined,
  minLengthMessage: undefined,
  placeholder: undefined,
  minLength: 5,
  maxLength: 15,
};

const preprocessPhoneNumber = val => {
  const regex = /^\+?[0-9]*$/;
  if (!val || regex.test(val)) {
    return val;
  }

  const prefix = val[0] === '+' ? '+' : '';
  return prefix + val.replace(/[^0-9]/g, '');
};

const PhoneField = props => {
  const {
    minLength,
    isSender,
    maxLength,
    invalidMessage = isSender
      ? I18n.t(VALIDATE_MESSAGE.PHONE_SENDER_INVALID)
      : I18n.t(VALIDATE_MESSAGE.PHONE_RECEIVER_INVALID),
    placeholder = I18n.t(FIELD_PLACEHOLDER.MOBILE_NUMBER),
    maxLengthMessage = I18n.t(VALIDATE_MESSAGE.PHONE_MAX_LENGTH, { maxLength }),
    minLengthMessage = I18n.t(VALIDATE_MESSAGE.PHONE_MIN_LENGTH, { minLength }),
  } = props;
  return (
    <InputField
      {...props}
      placeholder={placeholder}
      normalize={preprocessPhoneNumber}
      rules={[
        {
          required: true,
          message: invalidMessage,
        },
        {
          pattern: new RegExp(`^\\+?[0-9]{${minLength},}$`),
          message: minLengthMessage,
        },
        {
          pattern: new RegExp(`^\\+?[0-9]{0,${maxLength}}$`),
          message: maxLengthMessage,
        },
      ]}
    />
  );
};

PhoneField.propTypes = propTypes;
PhoneField.defaultProps = defaultProps;

export default PhoneField;
